export default __webpack_public_path__ + "static/media/guide0303_m.946c8b3c.jpg";